export { default } from './ParcelSize';
